import { CpfDetailsData, CpfDetailsMapperData } from "../types/details/cpfDetails.type";
import { formatDate } from "../utils/formatters";

export class ImportDetailsMapper {
  static cpfDetails() : (data: CpfDetailsData) => CpfDetailsMapperData[] {
    return (data: CpfDetailsData) => {
      const entries = Object.entries(data);
      const filteredData = entries.filter(([, value]) => value);

      return filteredData.map(([field, value]) => {
        if (field === 'date_of_birth') {
          return [field, formatDate(new Date(String(value) || '')) || ''];
        }

        if (field === 'email') {
          return [field, (value as CpfDetailsData['email']).email || ''];
        }

        return [field, String(value)];
      });
    };
  }
}
